<template>
  <div class="betgameeditteamscompetitions" id="betgameeditteamscompetitions">

    <NavigationBar>
      <template v-slot:left>
        <img class="back" src="../assets/icons/ic_16_back.svg" v-on:click="goBack">
      </template>
      <template v-slot:center>
        {{ $t('create_betgame.select_competitions') }}
      </template>
      <template v-slot:right>
      </template>
    </NavigationBar>

    <div v-for="ctx in contexts" :key="ctx.id" class="input-container" style="margin-top: 16px; padding-bottom: 16px;">
      <div class="input-header">{{ ctx.title }}</div>
      <checkbox-group
        v-model="ctx.selected"
        :options="ctx.options"
        select-all-label="Alle auswählen"
        @input="onChange($event, ctx.id)"
      />
      <!--<p><strong>Auswahl ({{ ctx.title }}):</strong> {{ ctx.selected }}</p>-->
    </div>

  </div>
</template>

<script>

import NavigationBar from './../components/NavigationBar'
import APIService from '@/services/APIService'
import CheckboxGroup from '@/components/CheckboxGroup.vue'

export default {
  name: 'BetgameEditTeamsCompetitions',
  components: { NavigationBar, CheckboxGroup },
  data () {
    return {
      betgame: null,
      errors: [],
      contexts: []
    }
  },
  created () {
    this.betgame = this.$route.params.betgame
    this.contexts = this.$route.params.contexts
  },
  mounted () {
    if (this.betgame === null || this.betgame === undefined ||
      !this.$store.state.betgameTeamCompetitions || this.$store.state.betgameTeamCompetitions.length === 0) {
      this.goBack()
    }
    var teams = ''
    for (var i = 0; i < this.$store.state.betgameTeamCompetitions.length; i++) {
      if (teams !== '') {
        teams += ','
      }
      teams += this.$store.state.betgameTeamCompetitions[i].fk_team
    }
    APIService.getCompetitionsByTeamsAndSeason(teams, this.$store.state.betgame.season.id).then(response => {
      var data = response.data
      const result = Object.values(
        data.reduce((acc, item) => {
          const teamId = item.bg_team.id

          if (!acc[teamId]) {
            acc[teamId] = {
              id: teamId,
              team: item.bg_team.name,
              competitions: []
            }
          }

          acc[teamId].competitions.push({
            id: item.bg_competition.id,
            name: item.bg_competition.name
          })

          return acc
        }, {})
      )
      this.setContexts(result)
    }).catch(error => {
    })

  },
  computed: {},
  methods: {
    onChange (competitions, team) {
      for (var i = 0; i < competitions.length; i++) {
        const toSave = {
          fk_team: team,
          fk_competition: competitions[i],
          fk_betgame: this.$store.state.betgame.id,
          fk_season: this.$store.state.betgame.season.id
        }
        const t = this.$store.state.betgameTeamCompetitions.filter(c => c.fk_team === team && c.fk_competition === competitions[i] &&
          c.fk_betgame === this.$store.state.betgame.id && c.fk_season === this.$store.state.betgame.season.id)
        if (!t || t.length === 0) {
          this.$store.dispatch('putBetgameTeamCompetitions', toSave).then(() => {
          }).catch(error => {
            this.errors.push(error)
          })
        }
      }
    },
    goBack () {
      this.$router.push('/betgameedit')
    },
    getCompetitionsByTeam (teamId, records) {
      return records.filter(r => r.fk_team === teamId).map(r => r.fk_competition)
    },
    filterFullySelected (data) {
      return data.filter(item => item.options.length !== item.selected.length)
    },
    filterAndClean (data) {
      return data.filter(item => item.options.length !== item.selected.length).map(item => ({
        ...item,
        options: item.options.filter(opt => !item.selected.includes(opt.id))
      }))
    },
    setContexts (n) {
      this.contexts = Array.from({ length: n.length }, (_, i) => ({
        id: n[i].id,
        title: n[i].team,
        options: n[i].competitions,
        selected: this.getCompetitionsByTeam(n[i].id, this.$store.state.betgameTeamCompetitions)
      }))
      this.contexts = this.filterAndClean(this.contexts)
    }
  }
}
</script>

<style lang="scss" scoped>
.betgameeditteamscompetitions {

  form {
    padding-top: 16px;
  }

  h1 {
    text-align: center;
  }

  p {
    text-align: center;
    margin-bottom: 26px;
  }
}


.grouped {
  margin-top: -16px;
}

.table-view {
  margin-bottom: 0;
}

.table-view-cell:last-child {
  border-bottom: 0;
}

.table-view-cell-label {
  color: rgba($colorGreyDark, .48);
  font-weight: 400;
}
</style>
